import { ArrowRight, Clock } from 'lucide-react';

const CaseStudiesPage = () => {
  return (
    <div className="pt-24">
      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6">
              Real Results from <span className="text-primary-500">Real Restaurants</span>
            </h1>
            <p className="text-xl text-gray-500 leading-relaxed">
              We're in alpha, working hands-on with our first restaurants. Case studies are coming as soon as we have real results to share.
            </p>
          </div>
        </div>
      </section>

      {/* Coming Soon */}
      <section className="py-20 bg-gray-50 border-y border-gray-200">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-2xl mx-auto text-center bg-white rounded-2xl border border-gray-200 shadow-lg p-12">
            <div className="w-16 h-16 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center mx-auto mb-6 border border-primary-100">
              <Clock size={28} />
            </div>
            <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Case Studies Coming Soon</h2>
            <p className="text-gray-600 leading-relaxed">
              ShiftCheck is currently onboarding its first restaurants. As those partnerships mature, we'll publish real, named case studies here — no fabricated numbers, no anonymous composites.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-primary-900">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6">
            Ready to Write Your Success Story?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-2xl mx-auto">
            Join the restaurants that are transforming their operations with ShiftCheck.
          </p>
          <a
            href="https://app.shiftcheck.app/signup"
            className="inline-flex items-center justify-center gap-2 bg-white text-primary-900 px-8 py-4 rounded font-bold hover:bg-gray-100 transition-all"
          >
            Start Free Trial
            <ArrowRight size={18} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default CaseStudiesPage;
